import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { EndpointLocationProviderService } from './endpoint-location-provider.service';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  private env = environment;

  constructor(private http: HttpClient,
    private endpointLocationService: EndpointLocationProviderService) { }

  logger(error: any): Observable<boolean> {
    return this.http
      .post(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_LOGGER)}/api/Add`, error)
      .pipe(
        map(_ => {
          return true;
        }));
  }
}
